import React from "react";
import { useNavigate } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { useT } from "@/i18n/LanguageContext";

// Advance / NA / Flagged / Pending → Pre Order (Back Office + Super Admin).
export function BackToPreOrderButton({ order, testid = "back-to-pre-order" }) {
  const { t } = useT();
  const qc = useQueryClient();
  const navigate = useNavigate();
  const m = useMutation({
    mutationFn: (reason) => api.post(`/orders/${order.id}/back-to-pre-order`, { reason }),
    onSuccess: () => {
      qc.invalidateQueries();
      toast.success(`${order.po_number} → ${t("Pre Orders")}`);
      navigate("/orders/pre_order");
    },
    onError: (e) => toast.error(e?.response?.data?.detail || t("Could not move to Pre Order")),
  });
  if (order?.claim_id) return null;
  return (
    <Button
      data-testid={testid}
      variant="outline"
      disabled={m.isPending}
      className="border-amber-500 text-amber-700 hover:bg-amber-50 whitespace-nowrap"
      title={t("Send this order back to the Pre Orders tab for a fresh review")}
      onClick={() => {
        const reason = window.prompt(t("Reason for sending this order back to Pre Order? (optional)"), "");
        if (reason === null) return;
        m.mutate(reason || "");
      }}
    >
      ↩ {m.isPending ? t("Moving…") : t("Back to Pre Order")}
    </Button>
  );
}
